export class DeleteAssessmentRequestDto {
  instanceId: string

  constructor(init?: Partial<DeleteAssessmentRequestDto>) {
    Object.assign(this, init)
  }
}
